<template>
        <div class="brand-item"  @click="toBrandList(brandItem.id)">
            <img :src="brandItem.bigPic">
            <div class="brand-info">
                <p v-if="langType=='cn'" style="font-weight: 600; font-size: 15px; letter-spacing:1px; ">{{brandItem.nameCn}}</p>
                <p v-if="langType=='en'" style="font-weight: 600; font-size: 15px; letter-spacing:1px; ">{{brandItem.nameEn}}</p>

    <!--            <span class="collect">{{goodItem.description}}</span>-->
    <!--            <span></span>-->
            </div>
            <div style="height: 25px">

            </div>
        </div>
</template>

<script>
    import { langPackage } from "@/config/lang/brand";
    import { selectLang } from "@/config/setLanguage"
    export default {
        name: "brandItem",
        data(){
            return{
                langType:"cn"
            }
        },
        props:{
            //设置传输的 属性对象 type: Object为obj 类型
            brandItem: {
                type: Object,
                default(){
                    return {}
                }
            }
        },
        created() {
            selectLang(langPackage).then(langtxt =>{
                this.langType = langtxt.type;
            });
        },
        methods:{
          toBrandList(id) {
            this.$router.push({path: '/goods/GoodsList', query: {'brandId': id}})
          }
        }
    }
</script>

<style scoped>

    .brand-item {
        width: 100%;
        padding-bottom: 60px;
        position: relative;
        background: #ffffff;
        margin: 10px;
        border-radius: 10px;
    }

    .brand-item img {
        width: 100%;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }

    .brand-info {
        font-size: 20px;
        position: absolute;
        bottom: 50px;
        left: 0;
        right: 0;
        overflow: hidden;
        text-align: center;
        border-bottom: 10px;
        margin: 10px;
    }

    .brand-info p{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 3px;
    }

    /*.brand-info .price {*/
    /*    color: var(--color-high-text);*/
    /*    margin-right: 20px;*/
    /*}*/
    /*收藏*/
    .brand-info .collect {
        position: relative;
    }

    .brand-info .collect::before {
        content: '';
        position: absolute;
        left: -15px;
        top: -1px;
        width: 14px;
        height: 14px;
        /*background: ;*/
    }

</style>
